import { render, staticRenderFns } from "./DistributionHistogram.vue?vue&type=template&id=9c3ebfc2&"
import script from "./DistributionHistogram.vue?vue&type=script&lang=js&"
export * from "./DistributionHistogram.vue?vue&type=script&lang=js&"
import style0 from "./DistributionHistogram.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports